import {
    TAGS_LIST_REQUESTED,
    TAGS_LIST_SUCCEEDED,
    TAGS_LIST_FAILED,
    LITTER_REPORT_REQUESTED,
    LITTER_REPORT_SUCCEEDED,
    LITTER_REPORT_FAILED,
    LITTER_REPORT_COUNT_REQUESTED,
    LITTER_REPORT_COUNT_SUCCEEDED,
    LITTER_REPORT_COUNT_FAILED,
    CLEAR_SELECTED_FILTER,
    FORM_SUBMISSION_REQUESTED,
    FORM_SUBMISSION_FAILED,
    FORM_SUBMISSION_SUCCEEDED,
    CLEAR_FORM_MESSAGE,
    SEND_LITTER_REPORT_REQUESTED,
    SEND_LITTER_REPORT_SUCCEEDED,
    SEND_LITTER_REPORT_FAILED,
    MAP_DATA_SUCCEEDED,
    MAP_DATA_FAILED,
    COUNTRIES,
} from './constants';

const initialState = {
    // list of countries to show in countries dropdown
    countries: COUNTRIES || [],
    isCountriesLoading: false,

    // list of tags to show in tags dropdown
    tags: [],
    isTagsLoading: false,

    // zipCode/city entered by user
    zipCity: null,

    // radius selected by user
    radius: 1,

    // start date selected by user
    startDate: null,

    // end date selected by user
    endDate: null,

    // initial state of error
    error: '',

    // litter to show based on selected filter
    litterReport: null,
    litterReportCount: 0,
    isReportLoading: false,
    isLitterReportCountLoading: false,

    // initial state of form Details
    formDetails: {
        name: '',
        email: '',
        phone: '',
        organization: '',
        purpose: '',
        reference: '',
        extraInfo: '',
        expandedData: '',
    },

    formMessage: null,
    // user's details to send report on
    requestDetails: null,
    sendReportError: null,
    sendReportSuccessMessages: null,
    reportSuccess: false,
    isFormSubmitting: false,

    mapData: [],
};

export default function(state = initialState, action) {
    switch (action.type) {
        case TAGS_LIST_REQUESTED: {
            return {
                ...state,
                isTagsLoading: true,
                error: null,
            };
        }
        case TAGS_LIST_SUCCEEDED: {
            const { tags } = action;
            return {
                ...state,
                tags,
                isTagsLoading: false,
                error: null,
            };
        }
        case TAGS_LIST_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                isTagsLoading: false,
            };
        }
        case LITTER_REPORT_REQUESTED: {
            const { selectedFilter } = action;
            const { litterReportCount } = state;
            const { offset } = selectedFilter;
            const resetLitterReportCount = offset > 0 ? litterReportCount : 0;
            return {
                ...state,
                selectedFilter,
                isReportLoading: true,
                error: null,
                sendReportSuccessMessages: null,
                sendReportError: null,
                reportSuccess: false,
                isMapLoading: true,
                litterReportCount: resetLitterReportCount,
            };
        }
        case LITTER_REPORT_SUCCEEDED: {
            const { litterReport } = action;
            return {
                ...state,
                litterReport,
                isReportLoading: false,
                error: null,
                reportSuccess: true,
            };
        }
        case LITTER_REPORT_FAILED: {
            const { error } = action;
            return {
                ...state,
                error,
                isReportLoading: false,
                reportSuccess: false,
            };
        }
        case LITTER_REPORT_COUNT_REQUESTED: {
            const { selectedFilter } = action;
            return {
                ...state,
                isLitterReportCountLoading: true,
                selectedFilter,
                error: null,
            };
        }
        case LITTER_REPORT_COUNT_SUCCEEDED: {
            const { litterReportCount } = action;
            return {
                ...state,
                isLitterReportCountLoading: false,
                litterReportCount,
                error: null,
            };
        }
        case LITTER_REPORT_COUNT_FAILED: {
            const { error } = action;
            return {
                ...state,
                isLitterReportCountLoading: false,
                error,
            };
        }
        case CLEAR_SELECTED_FILTER: {
            return {
                ...state,
                selectedFilter: null,
                litterReportCount: 0,
                litterReport: [],
            };
        }
        case FORM_SUBMISSION_REQUESTED: {
            const {
                name,
                email,
                phone,
                organization,
                purpose,
                reference,
                extraInfo,
                expandedData,
            } = action;
            return {
                ...state,
                formDetails: {
                    name,
                    email,
                    phone,
                    organization,
                    purpose,
                    reference,
                    extraInfo,
                    expandedData,
                },
                isFormSubmitting: true,
            };
        }
        case FORM_SUBMISSION_FAILED: {
            const { error } = action;
            return {
                formMessage: error,
                isFormSubmitting: false,
            };
        }
        case FORM_SUBMISSION_SUCCEEDED: {
            const { message } = action;
            return {
                formMessage: message,
                isFormSubmitting: false,
            };
        }
        case CLEAR_FORM_MESSAGE: {
            return {
                ...state,
                formMessage: null,
            };
        }
        case SEND_LITTER_REPORT_REQUESTED: {
            const { requestDetails } = action;
            return {
                ...state,
                requestDetails,
                isReportSendingInProgress: true,
                sendReportSuccessMessages: null,
                sendReportError: null,
            };
        }
        case SEND_LITTER_REPORT_SUCCEEDED: {
            const { success } = action;
            return {
                ...state,
                isReportSendingInProgress: false,
                sendReportSuccessMessages: success,
                sendReportError: null,
            };
        }
        case SEND_LITTER_REPORT_FAILED: {
            const { error } = action;
            return {
                ...state,
                isReportSendingInProgress: false,
                sendReportError: error,
                sendReportSuccessMessages: null,
            };
        }
        case MAP_DATA_SUCCEEDED: {
            const { mapData } = action;
            return {
                ...state,
                mapData,
                isMapLoading: false,
            };
        }
        case MAP_DATA_FAILED: {
            const { error } = action;
            return {
                ...state,
                mapError: error,
                isMapLoading: false,
            };
        }
        default:
            return state;
    }
}
